export default function Guibo({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1457 1457"
      className={className}
      width="16"
      height="16"
    >
      <g transform="translate(-82 -76)">
        <path d="M82 76h1457v1457H82z" style={{ fill: 'none' }} />
        <clipPath id="a">
          <path d="M82 76h1457v1457H82z" />
        </clipPath>
        <g clipPath="url(#a)">
          <path d="M37.085 346.284h1660.284v1660.284H37.085z" style={{ fill: '#f60', stroke: '#fff', strokeWidth: '71.16px' }} transform="translate(1 -291.26) scale(.93157)" />
          <g transform="translate(1 -291.26) scale(.93157)">
            <g style={{ filter: 'url(#b)' }} transform="matrix(2.63229 0 0 2.63229 -132.423 -631.839)">
              <path d="m150.176 505.578 47.821 67.475 164.718 83.541.759-125.311-164.718-54.624-48.58 28.919Z" style={{ fill: '#707070', fillOpacity: '.43', fillRule: 'nonzero' }} />
            </g>
            <circle cx="846.787" cy="1159.069" r="394.843" style={{ fill: '#707070', fillOpacity: '.17' }} />
            <circle cx="846.787" cy="1159.069" r="481.332" style={{ fill: '#707070', fillOpacity: '.17' }} />
            <path
              d="M255.361 680.184 381.24 857.799l433.584 219.904 1.998-329.856-433.583-143.784-127.878 76.121ZM313.897 1587.647l120.21 126.428 381.357-290.163-2.073-310.888-381.357 201.041-118.137 273.582ZM1370.918 1583.502l-120.21 126.428-381.357-290.163 2.073-310.888 381.356 201.041 118.138 273.582Z"
              style={{
                fill: '#fff',
                fillRule: 'nonzero',
                stroke: '#000',
                strokeOpacity: '.34',
                strokeWidth: '2px',
              }}
            />
            <path
              d="m1438.213 680.184-125.88 177.615-433.583 219.904-1.999-329.856 433.584-143.784 127.878 76.121Z"
              style={{
                fill: '#fff',
                fillRule: 'nonzero',
                stroke: '#000',
                strokeOpacity: '.34',
                strokeWidth: '2px',
                strokeLinejoin: 'round',
              }}
            />
          </g>
        </g>
      </g>
      <defs>
        <filter id="b" width="223.882" height="190.519" x="144.884" y="471.367" filterUnits="userSpaceOnUse">
          <feGaussianBlur in="SourceGraphic" stdDeviation=".882" />
        </filter>
      </defs>
    </svg>
  );
}
